const LoadingActionTypes = {
  LOADING: 'LOADING',
  LOADING_NEXT: 'LOADING_NEXT',
  PAYMENT_LOADING: 'PAYMENT_LOADING',
}

export default LoadingActionTypes
